// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"896d869a","124":"4fbd93c7","239":"5609229f","264":"3e632b4b","429":"c6ac1cf4","453":"f192ab00","480":"95c0e143","638":"538cd23e"}[chunkId] + ".chunk.js";
};